import Grid from '@mui/material/Grid';

import Button, { ButtonVariant } from '@/components/BaseLibrary/Button/Button';
import useSharedStyles from '@/components/HighlightImageTextStacked/SharedStackedStyles.styles';
import GridContainer from '@/components/Layout/GridContainer/GridContainer';
import type { ButtonContent } from '@/components/OldButton/OldButton';
import SectionHeader from '@/components/SectionHeader/SectionHeader';
import { brandColors } from '@/styles/theme/values/brandColors';

import useStyles from './HeaderAndCTA.styles';

interface Props {
  isOnDark: boolean;
  eyebrow?: string;
  headline?: string;
  subheading?: string;
  headerCta?: ButtonContent;
  fullWidth?: boolean;
}

export default function HeaderAndCTA({
  isOnDark,
  eyebrow,
  headline,
  subheading,
  headerCta,
  fullWidth,
}: Props) {
  const cta = headerCta ? { ...headerCta.fields } : null;
  const { classes } = useStyles();
  const { classes: sharedClassees } = useSharedStyles({ isOnDark });

  return (
    <GridContainer fixed>
      <Grid
        style={{
          color: isOnDark
            ? brandColors.tintsOffWhite40
            : brandColors.tintsNeutral20,
        }}
        size={{
          xs: 12,
          md: fullWidth ? 12 : 6,
        }}
      >
        {headline && (
          <SectionHeader
            eyebrow={eyebrow}
            heading={headline}
            subheading={subheading}
            isOnDark={isOnDark}
            className={sharedClassees.sectionHeader}
            fixed={true}
          />
        )}
      </Grid>
      {cta && (
        <Grid
          className={classes.optionalCTAGrid}
          size={{
            xs: 12,
            md: fullWidth ? 12 : 6,
          }}
        >
          <div className={classes.optionalCTAContainer}>
            <Button
              isOnDark={isOnDark}
              variant={ButtonVariant.SECONDARY}
              label={cta?.label}
              href={cta?.url}
            />
          </div>
        </Grid>
      )}
    </GridContainer>
  );
}
